<template>
  <PopupBox :title="$t('login')" v-if="showLoginDialog">
    <template v-slot:control>
      <button class="btn btn-sm" @click="onClickClose">
        <show-icon name="close" size="sm"></show-icon>
      </button>
    </template>

    <div class="row justify-content-center">
      <div class="col-10">
        <p class="lead">{{ $t("aims_login") }}</p>
        <form @submit.prevent="goLogin" method="post">

          <div class="mb-3 form-group">
            <label for="login_username" class="float-left">{{ $t("username") }}</label>
            <input type="text" class="form-control" ref="login_username" placeholder="" required>
          </div>

          <div class="mb-3 form-group">
            <label for="login_password" class="float-left">{{ $t("password") }}</label>
            <input type="password" class="form-control" ref="login_password" placeholder="" required>
          </div>

          <button class="btn btn-success btn-lg btn-block" type="submit" id="submit">{{ $t("login") }}</button>

        </form>

      </div>
    </div>

  </PopupBox>
</template>

<script>
import AuthService from '@/services/AuthService';
import PopupBox from '@/components/PopupBox.vue';
import { errMsg } from '@/common/error_msg_helper';

export default ({
  name: 'LoginDialog',
  props: [
    "showLoginDialog"
  ],
  components: {
    PopupBox
  },
  emits: [
    "close-login",
    "login-successful"
  ],
  methods: {
    goLogin() {
      const username = this.$refs.login_username.value;
      const password = this.$refs.login_password.value;
      const returnTo = this.$route.query.returnTo;
      const thisHandle = this;

      console.log("Inside Login, returnTo: ", returnTo);

      AuthService.login(username, password).then(function(user) {
        console.log("Inside goLogin, user => ", user);
        thisHandle.$emit("login-successful", user);
      }).catch(function (error) {
        console.log("Inside goLogin, error => ", error);
        if (error.response) {
          if (error.response.status == 401) {
            // incorrect password
            alert(thisHandle.$t("login_failed") + ": Incorrect login or password");
          } else if (error.response.data.errors) {
            alert(thisHandle.$t("login_failed") + ":" + error.message + "\n" + errMsg(error.response.data.errors));
          } else {
            alert(thisHandle.$t("login_failed") + ":" + error.message);
          }
        } else {
          alert(thisHandle.$t("login_failed") + ": No response");
        }
      });
    },
    onClickClose() {
      this.$emit("close-login");
    }
  }
})
</script>
